import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=afd99d12&"
import script from "./ContactUs.vue?vue&type=script&lang=js&"
export * from "./ContactUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afd99d12')) {
      api.createRecord('afd99d12', component.options)
    } else {
      api.reload('afd99d12', component.options)
    }
    module.hot.accept("./ContactUs.vue?vue&type=template&id=afd99d12&", function () {
      api.rerender('afd99d12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Billings/ContactUs.vue"
export default component.exports